export enum DocumentsManagerHistory {
  GET_ASSIGNED_DOCUMENTS_HISTORY = "GET_ASSIGNED_DOCUMENTS_HISTORY",
  GET_ASSIGNED_DOCUMENTS_HISTORY_SUCCESS = "GET_ASSIGNED_DOCUMENTS_HISTORY_SUCCESS",
  GET_ASSIGNED_DOCUMENTS_HISTORY_FAIL = "GET_ASSIGNED_DOCUMENTS_HISTORY_FAIL",

  DELETE_ASSIGNED_DOCUMENTS = "DELETE_ASSIGNED_DOCUMENTS",
  DELETE_ASSIGNED_DOCUMENTS_SUCCESS = "DELETE_ASSIGNED_DOCUMENTS_SUCCESS",
  DELETE_ASSIGNED_DOCUMENTS_FAIL = "DELETE_ASSIGNED_DOCUMENTS_FAIL",

  GET_ASSIGNED_DOCUMENT_CONTENT = "GET_ASSIGNED_DOCUMENT_CONTENT",
  GET_ASSIGNED_DOCUMENT_CONTENT_SUCCESS = "GET_ASSIGNED_DOCUMENT_CONTENT_SUCCESS",
  GET_ASSIGNED_DOCUMENT_CONTENT_FAIL = "GET_ASSIGNED_DOCUMENT_CONTENT_FAIL",
}
